import request from '@/utils/http';

const urlBase = '/api-srm-web/supplier';

// 根据条件查询基本类型配置列表
export const getTypeConfigs = (params) => {
    return request({
        url: `${urlBase}/supplierTypeConfigs`,
        method: 'post',
        data: params
    });
};

// 基本类型配置新增
export const addTypeConfig = (params) => {
    return request({
        url: `${urlBase}/supplierTypeConfig`,
        method: 'post',
        data: params
    });
};

// 修改基本类型配置
export const updateTypeConfig = (params) => {
    return request({
        url: `${urlBase}/supplierTypeConfig/${params.id}`,
        method: 'put',
        data: params
    });
};

// 删除基本配置
export const deleteTypeConfigs = (params) => {
    return request({
        url: `${urlBase}/deleteSupplierTypeConfigs`,
        method: 'delete',
        data: params
    });
};

// 启用基本配置信息
export const startTypeConfigs = (params) => {
    return request({
        url: `${urlBase}/startSupplierTypeConfig`,
        method: 'post',
        data: params
    });
};

// 禁用基本配置信息
export const blockTypeConfigs = (params) => {
    return request({
        url: `${urlBase}/blockSupplierTypeConfig`,
        method: 'post',
        data: params
    });
};

// 查询TAB页配置列表
export const getTabConfigs = (params) => {
    return request({
        url: `${urlBase}/supplierTabConfigs`,
        method: 'post',
        data: params
    });
};

// TAB页配置批量新增或者修改
export const saveOrUpdateTabConfigs = (params) => {
    return request({
        url: `${urlBase}/saveOrUpdateTabConfigs`,
        method: 'post',
        data: params
    });
};

// 获取Tab信息
export const getTabConfig = (params) => {
    return request({
        url: `${urlBase}/getTabConfig`,
        method: 'get',
        data: params
    });
};

// 查询字段配置列表
export const getFieldConfigs = (params) => {
    return request({
        url: `${urlBase}/supplierBasicinfoConfigs`,
        method: 'post',
        data: params
    });
};

// 字段配置批量新增或者修改
export const saveOrUpdateBasicInfoConfigs = (params) => {
    return request({
        url: `${urlBase}/saveOrUpdateBasicInfoConfigs`,
        method: 'post',
        data: params
    });
};

// 查询资质配置列表
export const getQualificationConfigs = (params) => {
    return request({
        url: `${urlBase}/supplierQualificationConfigs`,
        method: 'post',
        data: params
    });
};

// 资质配置批量新增或者修改
export const saveOrUpdateQualificationConfigs = (params) => {
    return request({
        url: `${urlBase}/saveOrUpdateQualificationConfigs`,
        method: 'post',
        data: params
    });
};